<template>
  <div
    v-if="inspiration && document"
    data-test="inspiration-image"
  >
    <a @click="show_modal = true">
      <div class="card-image">
        <img
          class="cover-fit has-rounded-corners"
          :src="document.attributes.file_url_m"
          style="height: 400px"
        />
      </div>
    </a>
    <b-modal
      v-model="show_modal"
      :width="1000"
    >
      <figure class="image">
        <img
          alt="Image"
          class="has-rounded-corners max-h-[85vh] w-full object-contain"
          :src="document.attributes.file_url_l || document.attributes.file_url"
        />
        <ButtonDestructive
          class="!fixed right-5 bottom-5"
          @onClick="deleteInspiration"
        >
          {{ $t('inspiration.actions.delete') }}
        </ButtonDestructive>
      </figure>
    </b-modal>
  </div>
</template>

<script setup>
import { computed, ref } from 'vue';
import { useStore } from 'vuex';
import useGlobalConfirm from '@/composables/useGlobalConfirm';

const props = defineProps({
  inspiration: { type: Object, required: true },
});

const store = useStore();
const { confirm } = useGlobalConfirm();

const show_modal = ref(false);

const documents = computed(() => store.getters.documents);

const document = computed(() =>
  _.isEmpty(documents.value)
    ? null
    : _.filter(documents.value, {
        attributes: { attachable_id: props.inspiration.id, attachable_type: props.inspiration.type },
      })[0],
);

const deleteInspiration = async () => {
  show_modal.value = false;
  const confirmed = await confirm({ destructive: true });
  if (!confirmed) return;
  store.dispatch('DELETE_INSPIRATION', { record: props.inspiration });
};
</script>
